var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66347 17.5H14.3364M11.9999 3.5V4.5M18.3639 6.13604L17.6568 6.84315M21 12.4999H20M4 12.4999H3M6.34309 6.84315L5.63599 6.13604M8.46441 16.0356C6.51179 14.0829 6.51179 10.9171 8.46441 8.96449C10.417 7.01187 13.5829 7.01187 15.5355 8.96449C17.4881 10.9171 17.4881 14.0829 15.5355 16.0356L14.9884 16.5827C14.3555 17.2155 13.9999 18.0739 13.9999 18.969V19.5C13.9999 20.6046 13.1045 21.5 11.9999 21.5C10.8954 21.5 9.99995 20.6046 9.99995 19.5V18.969C9.99995 18.0739 9.6444 17.2155 9.01151 16.5827L8.46441 16.0356Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.8dc1bea2bdcfd3b8dac195c97b6177f6.svg";
export { ForwardRef as ReactComponent };